import React, { useCallback, useEffect, useState } from 'react'

import { ComboFileSelectorProps } from './ComboFileSelector.types'

import GetModel from '../GetModel/GetModel'

import { getHost } from '../hooks'
import { FileInput } from '../atoms'

import { SelectCloudArtifacts } from '../SelectCloudArtifacts/SelectCloudArtifacts'

import { ArrowUpSquare, CloudPlus, FileEarmarkArrowUp, Laptop } from 'react-bootstrap-icons'

import ButtonGroup from '../atoms/ButtonGroup/ButtonGroup'
import SelectLocalArtifactNative from '../SelectLocalArtifactNative/SelectLocalArtifactNative'
import { LocalArtifactData } from '../SelectLocalArtifactNative/SelectLocalArtifactNative.types'
import { FileMeta } from '@pollination-solutions/pollination-sdk'

export const ComboFileSelector: React.FC<ComboFileSelectorProps> = ({ 
  projectOwner,
  projectName,
  value,
  hidden = false,
  disabled = false,
  defaultOption,
  optionsConfig,
  mode = 'cloud',
  onChange,
  client,
  inputProps
}) => {

  const host = getHost()

  const [option, setOption] = useState(() => {    
    if(defaultOption == null) return

    if (host !== 'web') {
      if (mode !== 'cloud') {
        // plugin, local
        return 'get_local'
      } else {
        // plugin, cloud
        return 'get_cloud'
      }
    } else {
      // web, cloud
      return 'get_cloud'
    }
  })

  useEffect(() => {
    setOption(defaultOption)
  }, [defaultOption])

  // const handleLocalArtifactSelect = useCallback((path: string) => {
  //   onChange({ pollination_local_path: path })
  // }, [onChange])

  // reset onChange if option
  useEffect(() => {
    !hidden && onChange()
  }, [option])

  return (
    <div data-testid="ComboFileSelector"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8
      }}
    >   
      {!hidden &&
        <ButtonGroup>
          { mode === 'cloud' && (typeof optionsConfig['get_file'] === 'undefined' || optionsConfig['get_file']) &&  
            <button
              type='button'
              disabled={disabled}
              onClick={() => setOption('get_file')}
              style={{
                display: 'flex',
                boxShadow: !disabled && option === 'get_file' ? 
                  'inset 0px 0px 9px 4px #096dd9' : undefined
              }}
            >
              <FileEarmarkArrowUp/>
            Upload
            </button>
          }
          {(typeof optionsConfig['get_cloud'] === 'undefined' || optionsConfig['get_cloud']) &&
            <button
              type='button'
              disabled={disabled}
              onClick={() => setOption('get_cloud')}
              style={{
                display: 'flex',
                boxShadow: !disabled && option === 'get_cloud' ? 
                  'inset 0px 0px 9px 4px #096dd9' : undefined
              }}
            >
              <CloudPlus/>
            Cloud
            </button>
          }
          { (host !== 'web' || option === 'get_model') &&
            (typeof optionsConfig['get_model'] === 'undefined' || optionsConfig['get_model']) &&
            <button
              type='button'
              disabled={disabled}
              onClick={() => setOption('get_model')}
              style={{
                display: 'flex',
                boxShadow: !disabled && option === 'get_model' ? 
                  'inset 0px 0px 9px 4px #096dd9' : undefined
              }}
            >
              <ArrowUpSquare/>
              CAD
            </button>
          }
          { (host !== 'web' || option === 'get_local') &&
            (typeof optionsConfig['get_local'] === 'undefined' || optionsConfig['get_local']) &&
            <button
              type='button'
              disabled={disabled}
              onClick={() => setOption('get_local')}
              style={{
                display: 'flex',
                boxShadow: !disabled && option === 'get_local' ? 
                  'inset 0px 0px 9px 4px #096dd9' : undefined
              }}
            >
              <Laptop/>
              Local
            </button>
          }
        </ButtonGroup>}
      {!hidden && (() => {
        switch(option){
          case 'get_file':
            return (
              <FileInput 
                onChange={onChange} 
                inputProps={inputProps} 
                accept={typeof inputProps.accept === 'string' ? 
                  inputProps.accept.split(', ') : undefined}
              />
            )
          case 'get_model':
            return (
              <GetModel
                defaultKey={projectName}
                onChange={onChange} 
                inputProps={inputProps} 
                showHelpText={false} 
                optionsConfig={{
                  selection: {
                    show: true,
                    selected: false,
                  },
                  subscribe: {
                    show: true,
                    selected: false,
                  },
                  preview: {
                    show: true,
                    selected: false,
                  }
                }}
              />
            )
          case 'get_cloud':
            return (
              <SelectCloudArtifacts 
                projectOwner={projectOwner}   
                projectName={projectName} 
                value={value as FileMeta}
                hidden={hidden}
                fileNameMatch={typeof inputProps.accept === 'string' ? 
                  `.*(${inputProps.accept.replace(/\./g, '').split(', ').join('$|')}$)` : '.*'}
                onChange={onChange} 
                client={client}
              />  
            )
          case 'get_local':
            return (
              <SelectLocalArtifactNative
                onChange={onChange}
                value={value as LocalArtifactData}
                buttonLabel={inputProps?.accept 
                  ? `Select ${inputProps.accept.split(',').length > 1 
                    ? 'any of' 
                    : 'an'} ${inputProps.accept} ${inputProps.accept.split(',').length > 1 
                    ? 'file types' : 'file'}.`
                  : 'Select a file.'
                }
                fileMatchPattern={inputProps?.accept 
                  ? `File types ${inputProps.accept}|*${inputProps.accept.split(', ').join(';*')}` 
                  : 'File types | *.*'
                }
              />
            )
          default:
            return (
              <FileInput 
                onChange={onChange} 
                inputProps={inputProps} 
                accept={typeof inputProps.accept === 'string' ? 
                  inputProps.accept.split(', ') : undefined}
              />
            )
        }
      })()}
    </div>
  )
}

export default ComboFileSelector